// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77b1cbbb","239":"7fe3e762","732":"f8880739","762":"3208d19a"}[chunkId] + ".chunk.js";
};